import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class ItemLabel extends Component {
	render() {
		const { label, unit } = this.props;
		return (
			<div className="bottle-selector-item-label">
				<span>{label}</span>
				<br />
				<span>{unit}</span>
			</div>
		);
	}
}

ItemLabel.propTypes = {
	label: PropTypes.string,
	unit: PropTypes.string
};

export default ItemLabel;
